import { h } from 'preact';

/**
 * DecorativeImage renders an image with an empty alt attribute so screen
 * readers skip it. Avoid role="presentation" on img — it can cause some
 * screen readers to still announce "image".
 * NOTE: all other passed in props are respected; alt and aria-hidden are
 * always enforced for accessibility.
 */
const DecorativeImage = (props) => {
  const { alt, ...restProps } = props;
  return <img {...restProps} alt="" aria-hidden="true" />;
};

export default DecorativeImage;
